import { gsap } from 'gsap'

function initDynamicCustomTextCursor() {
    let cursorItem = document.querySelector('.cursor-next-article')
    if (cursorItem == null) return
    let cursorParagraph = cursorItem.querySelector('p')
    let targets = document.querySelectorAll('[data-cursor-next-article]')
    let xOffset = 6
    let yOffset = -70
    let cursorIsOnRight = false
    let currentTarget = null
    let lastText = ''

    // Position cursor relative to actual cursor position on page load
    gsap.set(cursorItem, { xPercent: xOffset, yPercent: yOffset })

    // Use GSAP quick.to for a more performative tween on the cursor
    let xTo = gsap.quickTo(cursorItem, 'x', { ease: 'power3' })
    let yTo = gsap.quickTo(cursorItem, 'y', { ease: 'power3' })

    // Function to get the width of the cursor element including a buffer
    const getCursorEdgeThreshold = () => {
        return cursorItem.offsetWidth + 16 // Cursor width + 16px margin
    }

    // On mousemove, call the quickTo functions to the actual cursor position
    window.addEventListener('mousemove', (e) => {
        let windowWidth = window.innerWidth
        let windowHeight = window.innerHeight
        let scrollY = window.scrollY
        let cursorX = e.clientX
        let cursorY = e.clientY + scrollY // Adjust cursorY to account for scroll

        // Default offsets
        let xPercent = xOffset
        let yPercent = yOffset

        // Adjust X offset dynamically based on cursor width
        let cursorEdgeThreshold = getCursorEdgeThreshold()
        if (cursorX > windowWidth - cursorEdgeThreshold) {
            cursorIsOnRight = true
            xPercent = -100
        } else {
            cursorIsOnRight = false
        }

        // Adjust Y offset if in the bottom 10% of the current viewport
        if (cursorY > scrollY + windowHeight * 0.9) {
            yPercent = -120
        }

        if (currentTarget) {
            let newText = currentTarget.getAttribute('data-cursor')
            if (newText !== lastText) {
                // Only update if the text is different
                cursorParagraph.innerHTML = newText
                lastText = newText

                // Recalculate edge awareness whenever the text changes
                cursorEdgeThreshold = getCursorEdgeThreshold()
            }
        }

        gsap.to(cursorItem, {
            xPercent: xPercent,
            yPercent: yPercent,
            duration: 0.9,
            ease: 'power3'
        })
        xTo(cursorX)
        yTo(cursorY - scrollY)
    })
}

// Initialize Dynamic Text Cursor (Edge Aware)
document.addEventListener('DOMContentLoaded', () => {
    initDynamicCustomTextCursor()
})
